import {Injectable} from "@angular/core";
import {environment} from "../../../../environments/environment";



@Injectable()
export class FeatureService {
  private readonly features = environment.features as Partial<Features>;

  isEnabled(feature: keyof Features): boolean {
    return this.features?.[feature] || false;
  }
}

Object.assign(FeatureService.prototype, environment.features as Partial<Features>);

export interface Features {
  spf?: boolean
}
